import { createFileRoute } from '@tanstack/react-router';

import { getJobPositionQueryOptions } from '@/_pages/settings/job-positions/api-service';
import Loading from '@/_pages/settings/job-positions/hiring/loading';

export const Route = createFileRoute('/_private/settings/job-positions/_template/$id/hiring')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getJobPositionQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Hiring',
    tabKey: 'settings/job-position/hiring',
  },
  pendingComponent: Loading,
});
